import * as React from "react";
import { InputWithAlert } from "../ui/input-with-alert";
import { formatDateString } from "@/styles";
import { useTranslation } from "react-i18next";
import UploadZgloszeniePodZezwoleniePopup from "../popups/documents/zgloszenie-pod-zezwolenie.popup";

export const DocumentZezwolenieTypyA = (props) => {
  const { document, clientId} = props;
  const { entityType, createdAt, status, validFrom, validTo, uniqueId, id } = document;
  const {
    zezwolenie_type,
    zgloszenie_date,
  } = document.metadata;

  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="pt-6">
        <InputWithAlert
          label={t('document_type')}
          disabled={true}
          type="text"
          value={entityType}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('created_at')}
          disabled={true}
          type="text"
          value={formatDateString(createdAt)}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('status')}
          disabled={true}
          type="text"
          value={status}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('unique_id')}
          disabled={true}
          type="text"
          value={uniqueId ? uniqueId : t('not_specified')}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('valid_from')}
          disabled={true}
          type="text"
          value={formatDateString(validFrom)}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('valid_to')}
          disabled={true}
          type="text"
          value={formatDateString(validTo)}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('ZGLOSZENIE')}
          disabled={true}
          type="text"
          value={zgloszenie_date ? formatDateString(zgloszenie_date): '-'}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>

      <div className="pt-6">
        <InputWithAlert
          label={t("oswiadczenie_type")}
          disabled={true}
          type="text"
          value={zezwolenie_type.value}
          inputClassName={"h-[40px] w-full  mt-2"}
        />
        </div>
        {(
          <UploadZgloszeniePodZezwoleniePopup
            clientId={clientId}
            zezwolenieId={id}
          />
        )}
    </div>
  )
}
